//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";


function billtoConfiguration() {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllBillto(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/billto-configuration/get-Billto?query=${query}`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }

    async function create(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(values)
            };
            let res = await fetch(
                `${config.host}/cdr-panel/billto-configuration/create`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }
    
    async function getAllAdminDetail(id) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let res = await fetch(`${config.host}/cdr-panel/billto-configuration/get-new-admin/${id}`, obj);
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    async function update(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values),
            };
            let res = await fetch(`${config.host}/cdr-panel/billto-configuration/update`, obj);
            let body = await res.json();
            return body;
        } 
        catch (err) {}
    }

    async function search(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/billto-configuration/search?query=${encodeURIComponent(query)}`,
                obj
            );
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    async function allAdminExport(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values),
            };
            let res = await fetch(`${config.host}/cdr-panel/create-new-admin/export`, obj);
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    return {
        getAllBillto,
        create,
        getAllAdminDetail,
        update,
        search,
        allAdminExport
    }
}

export default billtoConfiguration;